import { createFileRoute } from '@tanstack/react-router'
import { OAuthCallback } from '@/features/auth/login/oauth-callback'

export const Route = createFileRoute('/(auth)/callback')({
  component: OAuthCallback,
})